import $ from 'jQuery';

const animationDuration = 4000;

$(function () {
    $('.links__link').on('mouseenter', function () {
        var elTOAnimate = $(this).children().get(0);
        var scrollWidth = $($(elTOAnimate).children().get(0)).get(0).scrollWidth;
        var clientWidth = $($(elTOAnimate).children().get(0)).get(0).clientWidth;
        $(elTOAnimate)
            .stop()
            .animate(
                {
                    scrollLeft: scrollWidth - clientWidth,
                },
                animationDuration
            );
    });

    $('.links__link').on('mouseleave', function () {
        var elTOAnimate = $(this).children().get(0);
        $(elTOAnimate).stop().animate(
            {
                scrollLeft: 0,
            },
            animationDuration
        );
    });
});
